<template>
  <div>
    <Header class="relative z-20"/>
    
    <div v-if="$route.name === 'index' || $route.name === 'hakkimizda'" class="fixed inset-0 flex items-center justify-center pointer-events-none z-0 overflow-hidden">
      <nuxt-img
          format="webp"
          loading="eager"
          fetchpriority="high"
          src="/gomulu-logo.webp"
          alt="Gömülü Logo"
          class="w-64 h-auto sm:w-72 md:w-80 lg:w-96 xl:w-[26rem] 
                 object-contain opacity-50 lg:opacity-70 
                 transition-transform duration-300"
          style="filter: blur(0.2px);"
      />
    </div>
    
    <main class="relative z-20 min-h-screen">
        <slot />
    </main>

    <Footer class="relative z-10"/>
  </div>
</template>